<div class="d-flex flex-row justify-content-between border" style="height: calc(100vh - 50px);">
  <div class="d-flex flex-column flex-shrink-0 p-1 border-end h-100" style="flex-basis: 330px;">
    <!-- Fixed Header -->
    <div class="d-flex justify-content-between text-decoration-none mb-3 mb-md-0" id="header">
      @if (isAuthenticated) {
        <div class="fs-6 col-12">
          @if (authConfig.IsGallery) {
            <div class="fw-semibold">{{ 'chatBox.connectedArtists' | transloco }}</div>
          }
          @if (authConfig.IsArtist) {
            <div class="fw-semibold">{{ 'chatBox.connectedGalleries' | transloco }}</div>
          }
        </div>
      }
    </div>

    <!-- Search Bar -->
    <div class="d-flex mt-2 mb-2">
      <input type="text" class="form-control" [placeholder]="'chatBox.search' | transloco" #searchInput (keyup)="filterChatUsers(searchInput.value)">
    </div>

    <!-- Scrollable Content -->
    <div class="scroll flex-grow-1">
      @if (chatUsers.length > 0) {
        <ul class="nav nav-pills flex-column mb-auto">
          @for (user of chatUsers; track user; let item = $index) {
            <li class="nav-item">
              <a class="nav-link cursor-pointer d-flex border-bottom" [ngClass]="{'selected': user.Id === selectedUserId}" (click)="selectUser(user.Id)">
                <img [src]="user.ImgUrl || 'assets/images/No-Image.png'" class="flex-row rounded-pill contact-img" width="32" height="32" alt="pic">
                <div class="d-flex flex-column w-100">
                  <div class="d-flex justify-content-between cursor-pointer">
                    <span class="text-black">{{user.Name}}</span>
                    <span class="text-muted small">{{user.Time | date: 'HH:mm'}}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <div>
                      <span class="text-muted fst-italic cursor-pointer" [title]="user.LastMessage">
                        {{ getFirstSentence(user.LastMessage)}}
                      </span>
                    </div>
                    @if (user.UnreadMessageCount > 0) {
                      <span style="height: 20px;" class="badge bg-danger">{{ user.UnreadMessageCount }}</span>
                    }
                    @if (isUserOnline(user.Id)) {
                      <span class="badge bg-danger">{{ 'chatBox.online' | transloco }}</span>
                    }
                  </div>
                </div>
              </a>
            </li>
          }
        </ul>
      }
    </div>
  </div>

  @if (selectedUser) {
    <div class="flex-grow-1">
      <chat-messages [chatUsers]="chatUsers" [selectedUser]="selectedUser" [onlineUsers]="onlineUsers"
        (onNewMessageReceived)="onNewMessageReceived($event)">
      </chat-messages>
    </div>
  }
</div>